document.addEventListener("DOMContentLoaded", () => {
	// In View navigation events
	const tabLinks = document.querySelectorAll('.tab-content-link');
	const tabContents = document.querySelectorAll('.tab-content');

	if (tabLinks.length > 0 && tabContents.length > 0) {
		const inView = (target) =>{
			const io = new IntersectionObserver((entries,observer) => {
				entries.forEach(entry => {
					if(entry.isIntersecting) {
						let currentElementId = entry.target.getAttribute('id');

						tabLinks.forEach(tabLink => {
							let hash = tabLink.getAttribute('href').replace('#', '');

							if (hash !== currentElementId && tabLink.classList.contains('current')) {
								tabLink.classList.remove('current');
							} else if (hash === currentElementId && !tabLink.classList.contains('current')) {
								tabLink.classList.add('current');
							}
						});
					}
				})
			}, {threshold:[0.2]});

			io.observe(target);
		}

		tabContents.forEach(inView);
	}

	// Section Tabs
	const sectionTabs = document.querySelectorAll('.section-tab .tab__item');

	sectionTabs.forEach(sectionTabItem => {		
		const sectionTabItemHeader = sectionTabItem.querySelector('.section-tab__header');
		const sectionTabItemBody = sectionTabItem.querySelector('.section-tab__body');

		if (sectionTabItemHeader && sectionTabItemBody) {
			if (sectionTabItem.classList.contains('open')) {
				expandSection(sectionTabItemBody);
			}

			sectionTabItemHeader.addEventListener('click', () => {
				if (sectionTabItem.classList.contains('open')) {
					collapseSection(sectionTabItemBody);

					sectionTabItem.classList.remove('open');

					if (!multiLevelAccordion) {
						sectionTabs.forEach(item => {
							if (item.classList.contains('open')) {
								let itemBody = item.querySelector('.section-tab__body');

								if (itemBody) {
									collapseSection(itemBody);
								}

								item.classList.remove('open');
							}
						});
					}
				} else {
					sectionTabs.forEach(item => {
						if (item.classList.contains('open')) {
							let itemBody = item.querySelector('.section-tab__body');

							if (itemBody) {
								collapseSection(itemBody);
							}

							item.classList.remove('open');
						}
					});

					expandSection(sectionTabItemBody);

					sectionTabItem.classList.add('open');
				}
			});
		}
	});

	// Accordions
	const multiLevelAccordion = false;

	const collapsables = document.querySelectorAll('.collapsable');

	collapsables.forEach(collapsable => {
		const collapsableItems = collapsable.querySelectorAll('.collapsabel__item');
		const viewMoreButton = collapsable.querySelector('.btn-view-more');
		let hasHiddenItems = false;

		collapsableItems.forEach(collapsableItem => {
			if(collapsableItem.classList.contains('hidden')) {
				hasHiddenItems = true;
			}
			const collapsableItemHeader = collapsableItem.querySelector('.collapsabel__item__header');
			const collapsableItemBody = collapsableItem.querySelector('.collapsabel__item__body');

			if (collapsableItemHeader && collapsableItemBody) {
				if (collapsableItem.classList.contains('open')) {
					expandSection(collapsableItemBody);
				}

				if (! collapsableItem.hasAttribute('data-uncollapsible')) {
					collapsableItemHeader.addEventListener('click', () => {
						if (collapsableItem.classList.contains('open')) {
							collapseSection(collapsableItemBody);

							collapsableItem.classList.remove('open');

							if (!multiLevelAccordion) {
								collapsableItems.forEach(item => {
									if (!item.hasAttribute('data-uncollapsible')) {
										if (item.classList.contains('open')) {
											let itemBody = item.querySelector('.collapsabel__item__body');

											if (itemBody) {
												collapseSection(itemBody);
											}

											item.classList.remove('open');
										}
									}

								});
							}
						} else {
							if (!multiLevelAccordion) {
								collapsableItems.forEach(item => {
									if (item.classList.contains('open')) {
										let itemBody = item.querySelector('.collapsabel__item__body');

										if (itemBody) {
											collapseSection(itemBody);
										}

										item.classList.remove('open');
									}
								});
							}

							expandSection(collapsableItemBody);

							collapsableItem.classList.add('open');
						}
					});
				}
			}
		});

		if (viewMoreButton && hasHiddenItems) {
			viewMoreButton.addEventListener('click', () => {
				collapsableItems.forEach(collapsableItem => collapsableItem.classList.remove('hidden'));

				viewMoreButton.classList.add('hidden');
			});
		}
	});

	function collapseSection(element) {
	  // get the height of the element's inner content, regardless of its actual size
	  let sectionHeight = element.scrollHeight;
	  
	  // temporarily disable all css transitions
	  let elementTransition = element.style.transition;
	  element.style.transition = '';
	  
	  // on the next frame (as soon as the previous style change has taken effect),
	  // explicitly set the element's height to its current pixel height, so we 
	  // aren't transitioning out of 'auto'
	  requestAnimationFrame(function() {
		element.style.height = sectionHeight + 'px';
		element.style.transition = elementTransition;
		
		// on the next frame (as soon as the previous style change has taken effect),
		// have the element transition to height: 0
		requestAnimationFrame(function() {
		  element.style.height = '0px';
		});
	  });
	}

	function expandSection(element) {
	  // get the height of the element's inner content, regardless of its actual size
	  let sectionHeight = element.scrollHeight;
	  
	  // have the element transition to the height of its inner content
	  element.style.height = sectionHeight + 'px';

	  // when the next css transition finishes (which should be the one we just triggered)
	  element.addEventListener('transitionend', function(e) {
		// remove this event listener so it only gets triggered once
		element.removeEventListener('transitionend', arguments.callee);
		
		// remove "height" from the element's inline styles, so it can return to its initial value
		element.style.height = 'auto';
	  });
	}
});
